import VueFormGenerator from 'vue-form-generator';
export default {
  "admin-settings-email": {
    "type": "input",
    "inputType": "text",
    "label": "Administrator Email (sender)",
    "model": "admin-settings-email",
    "required": true,
    "validator": VueFormGenerator.validators.email
  },
  "setting-name": {
    "type": "input",
    "inputType": "text",
    "label": "Setting",
    "model": "setting-name",
    "required": true,
    validator: ['string'],
    max: 64
  },
  "setting-description": {
    "type": "input",
    "inputType": "text",
    "label": "Description",
    "model": "setting-description",
    "required": false,
    validator: ['string'],
    max: 256
  },
  "admin-settings-note-title": {
    "type": "input",
    "inputType": "text",
    "label": "Note Title",
    "model": "admin-settings-note-title",
    "required": true,
    validator: ['string'],
    max: 64
  },
  "admin-settings-note-title-placeholder": {
    "type": "input",
    "inputType": "text",
    "label": "Note Title Placeholder",
    "model": "admin-settings-note-title-placeholder",
    "required": true,
    validator: ['string'],
    max: 64
  },
  "admin-settings-note-body-placeholder": {
    "type": "input",
    "inputType": "text",
    "label": "Note Body Placeholder",
    "model": "admin-settings-note-body-placeholder",
    "required": true,
    validator: ['string'],
    max: 64
  },
  "admin-settings-note-button": {
    "type": "input",
    "inputType": "text",
    "model": "admin-settings-note-button",
    "label": "Save Note Button Text",
    "required": true,
    validator: ['string'],
    max: 120
  },

  "admin-settings-question-title": {
    "type": "input",
    "inputType": "text",
    "model": "admin-settings-question-title",
    "label": "Ask a Question Title",
    "required": true,
    validator: ['string'],
    max: 120
  },
  "admin-settings-question-email-placeholder": {
    "type": "input",
    "inputType": "text",
    "model": "admin-settings-question-email-placeholder",
    "label": "Email Placeholder Text",
    "required": true,
    validator: ['string'],
    max: 256
  },
  "admin-settings-question-subject-placeholder": {
    "type": "input",
    "inputType": "text",
    "model": "admin-settings-question-subject-placeholder",
    "label": "Subject Placeholder Text",
    "required": true,
    validator: ['string'],
    max: 256
  },
  "admin-settings-question-message-placeholder": {
    "type": "input",
    "inputType": "text",
    "model": "admin-settings-question-message-placeholder",
    "label": "Message Placeholder Text",
    "required": true,
    validator: ['string'],
    max: 256
  },

  "admin-settings-tab-transcript-name": {
    "type": "input",
    "inputType": "text",
    "model": "admin-settings-tab-transcript-name",
    "label": "Transcript Tab Name",
    "required": true,
    validator: ['string'],
    max: 64
  },
  "admin-settings-tab-speakers-name": {
    "type": "input",
    "inputType": "text",
    "model": "admin-settings-tab-speakers-name",
    "label": "Speakers Tab Name",
    "required": true,
    validator: ['string'],
    max: 64
  },
  "admin-settings-tab-bookmarks-name": {
    "type": "input",
    "inputType": "text",
    "model": "admin-settings-tab-bookmarks-name",
    "label": "Bookmarks Tab Name",
    "required": true,
    validator: ['string'],
    max: 64
  },
  "admin-settings-tab-notes-name": {
    "type": "input",
    "inputType": "text",
    "model": "admin-settings-tab-notes-name",
    "label": "Notes Tab Name",
    "required": true,
    validator: ['string'],
    max: 64
  },

  "admin-settings-tab-enable-transcripts": {
    "type": "input",
    "inputType": "checkbox",
    "model": "admin-settings-tab-enable-transcripts",
    "label": "Enable/Disable Transcripts",
  },
  "admin-settings-tab-enable-speakers": {
    "type": "input",
    "inputType": "checkbox",
    "model": "admin-settings-tab-enable-speakers",
    "label": "Enable/Disable Speakers",
  },
  "admin-settings-tab-enable-bookmarks": {
    "type": "input",
    "inputType": "checkbox",
    "model": "admin-settings-tab-enable-speakers",
    "label": "Enable/Disable Speakers",
  },

  /*"admin-settings-icon-uploader": {
    "inputType": "upload",
    "model": "admin-settings-icon-uploader",
    "label": "Uploade File",
    type:"upload",
    "inputName":"name input"
  },*/


};
